import React from "react";
import WholesalerOption from "./WholesalerOptions";

const steps = [
  {
    step: 1,
    title: "Register your Business",
    description: "Create your free account in just a few steps.",
  },
  {
    step: 2,
    title: "Manage Orders",
    description: "Receive and fulfill orders with our easy-to-use dashboard.",
  },
  {
    step: 3,
    title: "Grow your Network",
    description:
      "Connect with a growing community of retailers and scale your operations efficientl.",
  },
  {
    step: 4,
    title: "Insight and Support",
    description:
      "Gain valuable market insights and continuous support from the Pamundo team.",
  },
];

const WholesalerOptionsList: React.FC = () => {
  return (
    <div className="wholesaler-options">
      {steps.map(({ step, title, description }) => (
        <WholesalerOption
          key={step}
          step={step}
          title={title}
          description={description}
        />
      ))}
    </div>
  );
};

export default WholesalerOptionsList;
